module.exports = __webpack_public_path__ + "img/RJC_LP_fertigung@2x.15ba584.webp";